import { reduxForm } from 'redux-form';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

import { Filters } from 'libs/form';

const d = moment();
const initialFlt = {
  // status: 'active',
  timestamp_from: d.startOf('day').format(),
  timestamp_to: d.endOf('day').format(),
};

const Filter = ({ handleSubmit, reset, type, change, filter }) => {
  const { t } = useTranslation();

  const filters = [
    { type: 'doubledate', name: 'timestamp', title: t('grid.Дата и время'), change },
    { type: 'input', name: 'name', title: t('inputs.Пользователь'), placeholder: t('form.Иванов И.И.'), w: 290 },
    { type: 'role', name: 'role_id', multiple: true },
    { type: 'input', name: 'action', title: t('inputs.Описание'), placeholder: t('inputs.Введите название'), w: 230 },
  ];

  return <Filters items={filters} page={type} handleSubmit={handleSubmit} reset={reset} t={t} />;
};

export default reduxForm({
  form: 'actionFilter',
  destroyOnUnmount: false,
  initialValues: initialFlt,
})(Filter);
